import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import {
  handleLogin,
  handleLogOut,
  handleOtpverify,
  handleSinUp,
} from "../AuthServices/Vendor.authservices";
import { handleUserLoggedIn, handleUserSignUp } from "../AuthServices/user.authServices";





// Initial state for reuse

const initialState = {
  setVendor: {},
  setUser: {},
  Error: null,
  authToken: "",
  isAuthenticated: false,
  isLoading: false,
  isverify: false,
  isVendor: false,
  isCustomer: false,
  getCustomerId: "",
  getvendorId: "",
  statusCode: null,
};


const authanticatonStore = (set) => ({
  
  ...initialState, //expend initialState ...

  // Vendor Auth 

  signUpAsvendor: async (signUpFromData) => {
    set({ ...initialState, isLoading: true });
    try {
      const responseSignup = await handleSinUp(signUpFromData);

      set({
        ...initialState,
        isVendor: true,
        statusCode: responseSignup.status,
      });

      console.log("Response Signup data: ", responseSignup);
      return responseSignup?.data;
    } catch (error) {
      set({
        ...initialState,
        Error: error|| "Error occurred during vendor  sign-up",
      });
      console.log("Auth error sign up ", error);
      throw error;
    }

  },

  LoginAsVendor: async (vendorId) => {
    set({ ...initialState, isLoading: true });

    console.log("VId:",vendorId);
    try {
      const resLogIn = await handleLogin(vendorId);
  
      set({
         ...initialState,
        statusCode: resLogIn.status,
        getvendorId: vendorId,
      });

      console.log("resLogIn: ", resLogIn);
      return resLogIn.data.message;
    } catch (error) {
      set({
        ...initialState,
        Error: error.response?.data?.message || "Error occurred during Vendor Login",
      });

      throw error;   // 🔥 rethrow so handleSubmit can catch it
    }
  },

  VerifVendorOtp: async (code, vendorId) => {
    set({ ...initialState, isLoading: true });
    try {
      const resVerifyOtp = await handleOtpverify(code, vendorId);

      set({
        ...initialState,
        setVendor: resVerifyOtp?.user || {},
        authToken: resVerifyOtp.token,
        isAuthenticated: true,
        isverify: true,
        isVendor: resVerifyOtp?.user?.is_vendor === "1",
        getvendorId:vendorId
      });

      return resVerifyOtp;
    } catch (error) {
      set({
        ...initialState,
        Error: error.response?.data?.message || "OTP verification failed",
      });
      throw error;   // 🔥 rethrow so handleSubmit can catch it
    }
  },


  //user auth

  signUpAsUser:async(usersignUpData)=>{
    set({ ...initialState, isLoading: true });
    try {
      
      const resUsersignUp= await handleUserSignUp(usersignUpData);

      set({
        ...initialState,
        isCustomer: true,
        statusCode: resUsersignUp.status,
      });


      console.log("resUsersignUp in Auth Store: ",resUsersignUp);
      

      return resUsersignUp.data;


    } catch (error) {
      console.log("Error in user sign up store: ",error);
       set({
        ...initialState,
        Error: error|| "Error occurred during customer sign-up",
      });
       throw error;   // 🔥 rethrow so handleSubmit can catch it
    }
  },

  LoggedInAsUser:async(loggedinData)=>{
   set({ ...initialState, isLoading: true });
    try {
      const resLoggedUser=await handleUserLoggedIn(loggedinData);
      if(resLoggedUser){
        set({
        ...initialState,
        authToken:resLoggedUser?.data.token,
        setUser: resLoggedUser?.data?.user,
        isCustomer:resLoggedUser.data.user.is_customer==="1",
        isverify:true,
        isAuthenticated:true,

        statusCode: resLoggedUser.status,
      });
}
      // console.log("ResLoggedUser: ", resLoggedUser);
      return resLoggedUser.data;
    } catch (error) {
      set({
        ...initialState,
        Error: error.response?.data?.message || "Error occurred during user Login",
      });
      throw error;   // 🔥 rethrow so handleSubmit can catch it
    }

  },


   //for  all user

  handleLogOut: async (authToken) => {
    set({ isLoading: true });
    try {
      const res = await handleLogOut(authToken);
      set({ ...initialState });
      return res;
    } catch (error) {
      set({
        ...initialState,
        Error: error.response?.data?.message || "Logout failed",
      });
      console.log(error);
      throw error;   // 🔥 rethrow so handleSubmit can catch it
    }
  },
});

const useVendorStore = create(
  devtools(
    persist((set) => authanticatonStore(set), {
      name: "AuthToken",
    })
  )
);

export default useVendorStore;
